import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse, HttpHeaders, HttpParams, HttpResponse } from '@angular/common/http';

import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class HttpService {
  constructor(private http: HttpClient) {}

  get<T>(url: string, params?: HttpParams, headers?: HttpHeaders): Observable<HttpResponse<T>> {
    this.logRequest(url, params, headers);
    return this.http.get<T>(url, { params, headers, observe: 'response' }).pipe(catchError(this.handleError));
  }

  post<T>(url: string, body: any, params?: HttpParams, headers?: HttpHeaders): Observable<HttpResponse<T>> {
    this.logRequest(url, params, headers);
    return this.http.post<T>(url, body, { params, headers, observe: 'response' }).pipe(catchError(this.handleError));
  }

  put<T>(url: string, body: any, params?: HttpParams, headers?: HttpHeaders): Observable<HttpResponse<T>> {
    this.logRequest(url, params, headers);
    return this.http.put<T>(url, body, { params, headers, observe: 'response' }).pipe(catchError(this.handleError));
  }

  delete<T>(url: string, params?: HttpParams, headers?: HttpHeaders): Observable<HttpResponse<T>> {
    this.logRequest(url, params, headers);
    return this.http.delete<T>(url, { params, headers, observe: 'response' }).pipe(catchError(this.handleError));
  }

  private handleError(error: HttpErrorResponse) {
    // You can customize error handling based on your application's needs
    let errorMessage = 'An error occurred.\n';
    if (error.error instanceof ErrorEvent) {
      // Client-side error
      errorMessage += error.error.message;
    } else {
      // Server-side error
      errorMessage += `Error Code: ${error.status}\nMessage: ${error.message}`;
    }
    console.error(errorMessage);
    return throwError(() => error);
  }

  private logRequest(url: string, params?: HttpParams, headers?: HttpHeaders, body?: any): void {}
}
